import { render } from "./NewPasswordForm.vue?vue&type=template&id=712cf015&scoped=true"
import script from "./NewPasswordForm.vue?vue&type=script&lang=js"
export * from "./NewPasswordForm.vue?vue&type=script&lang=js"

import "./NewPasswordForm.vue?vue&type=style&index=0&id=712cf015&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712cf015"]])

export default __exports__